/* eslint-disable */
import RadioButtonAvailability from './RadioButtonAvailability'

export default RadioButtonAvailability



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/RadioButtonAvailability/index.js